<template>
  <form class="side_box" :style="style" @submit.prevent>
    <h4 class="content-subtitle">QR Code</h4>
    <div class="dhr-qr">
      <qr-code id="qrPrint" class="print" :text="qrString" :size="180" error-level="L" />
      <BaseButton size="semi" color="primary" @click.native="print()" class = 'printQR'>
        <span class="font-semi">Print QR-code</span>
        <BaseIcon name="print" class="icon white" />
      </BaseButton>
      <BaseButton size="semi" color="primary" @click.native="excel()" class = 'printQR'>
        <span class="font-semi">Generate Excel</span>
        <BaseIcon name="print" class="icon white" />
      </BaseButton>
    </div>
  </form>
</template>

<script>
import BaseButton from "@/components/base/Button";
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseButton,
    BaseIcon
  },
  computed: {
    style() {
      return "flex: 1";
    }
  },
  props: {
    details: Object
  },
  data() {
    return {
      qrString: ""
    };
  },

  mounted() {
    this.renderQR();
    let bon;

    // this.details.snummer != "" && this.details.snummer != "0"
    
  },
  methods: {
    renderQR() {
      if (this.details.bonID == "") {
        this.qrString =
          '{"result": "' +
          this.details.lotID +
          '", "name": "' +
          this.details.lotID +
          '", "snummer": "' +
          this.details.snummer +
          '", "type": "LOT", "company": "SurgiTec"}';
      } else {
        this.qrString =
          '{"result": "' +
          this.details.bonID +
          '", "name": "' +
          this.details.bonID +
          '", "snummer": "' +
          this.details.snummer +
          '", "type": "BON", "company": "SurgiTec"}';
      }
    },
    excel(){
      console.log(this.details)
      this.$http.get(this.$endpoint + 'production/generatepdf/' + this.details.DHRID)
      .then(response => {
      window.open(response.data.url);

      })
      .catch(error => {
        if (error.response.status === 401) {
          this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch(err => console.log(err));
        } else {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }`,
            'error'
          );
        }
      })
    },
    print() {
      let qr = document.getElementById("qrPrint").innerHTML;

      const y = window.top.outerHeight / 2 + window.top.screenY - 480 / 2;
      const x = window.top.outerWidth / 2 + window.top.screenX - 720 / 2;
      const WinPrint = window.open(
        "",
        "",
        `left=${x},top=${y},width=720,height=480,toolbar=0,scrollbars=0,status=0`
      );
      let bon;
      if (this.details.snummer != "" && this.details.snummer != "0") {
        bon = this.details.snummer;
      } else {
        if (this.details.lotID) {
          bon = this.details.lotID;
        } else {
          bon = this.details.bonID;
        }
      }
      WinPrint.document.write(
        "<html><head><title>Print QR</title><style>* { font-family: sans-serif; }</style>"
      );
      WinPrint.document.write("</head><body width=400>");
      WinPrint.document.write(qr);
      WinPrint.document.write('<p style ="font-size:12px;">');
      WinPrint.document.write(this.details.bonID ? "BATCH " : "LOT ");
      WinPrint.document.write(" : " + bon);
      WinPrint.document.write(
        ", REF: " +
          this.details.DHRREF.substring(0, this.details.DHRREF.lastIndexOf("-"))
      );
      WinPrint.document.write("</p>");
      WinPrint.document.write("</body></html>");

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      this.isPrinted = true;
      this.isIncomplete = false;
    }
  },
  watch: {
    details: {
      handler: function() {
        this.renderQR();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/pages/content";
@import "@/style/components/sideBox";
@import "@/style/components/inputs";
@import "@/style/components/buttons";

.font-semi{
  margin-bottom: 0 !important;
}
.print{
  padding-bottom: 20px;
}
.printQR{
  margin-bottom: 20px;
  height: 38px;
}
.side_box {
  max-height: 440px;

  h4 {
    width: 100%;
  }

  .qrcode {
    width: 100%;
    padding-top: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>
